
import React, { useState } from 'react'
import PropTypes from "prop-types"
import Styled from 'styled-components'
import { HiCollection } from 'react-icons/hi'
import { ActionButtonV4, FormContactUsV3 } from 'Components'
import { CSSTransition, TransitionGroup } from "react-transition-group"
import Config, { nav } from "Data"
const NoItem = Styled.div`
    border: 2px dashed #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    color: #d1d1d1;
    flex-direction: column;
`
const NoIcon = Styled.div`
    font-size: 4rem;
    color: #e0e0e0;
`
const NoText = Styled.div`
    font-size: 1.5rem;
    font-weight: 600;
`

const CTAbox = Styled.div`
    margin-top: 13px;
    border-top: 2px dashed #f5f5f5;
    width: 100%;
    text-align: center;
`
const NoItemFound = (props) => {
    const message = props?.message ? props.message : 'Events not found';
    const [currentModal, setCurrentModal] = useState(null);
    const [shareEvent, setShareEvent] = useState(null);
    const [showEvents, setShowEvents] = useState(false);

    const toggleModal = (key, param) => (e) => {
        e.preventDefault()
        if (currentModal) {
            handleModalCloseRequest()
            return
        }
        setCurrentModal(key);
        setShareEvent(param.shareEvent);
        setShowEvents(param.showEvents);
    }

    const handleModalCloseRequest = () => {
        setCurrentModal(null);
    }
    const handleOnAfterOpenModal = () => {

    }
    return (<NoItem>
        <FormContactUsV3
            title={`Have a question for the ${Config.brand} team?`}
            subtitle="Call us or submit below:"
            isOpen={currentModal === "modal_contactus"}
            onAfterOpen={handleOnAfterOpenModal}
            onRequestClose={handleModalCloseRequest}
            closeModal={toggleModal("modal_contactus")}
        />

        <NoIcon><HiCollection /></NoIcon>
        <NoText>{message}</NoText>
        {props.show_contact_modal && (
            <CTAbox>
                <TransitionGroup >
                    <CSSTransition classNames="fadedown" timeout={3000}>
                        <div
                            style={{
                                paddingTop: `33px`,
                                transitionDelay: `600ms`,
                            }}>
                            <ActionButtonV4
                                className={`action-cta`}
                                onClick={toggleModal("modal_contactus", {
                                    shareEvent: null,
                                    showEvents: false,
                                })}
                                title={`Contact Us`}
                                track={"Event Grid"}>
                                Host {Config.brand} event
                            </ActionButtonV4>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </CTAbox>
        )}
    </NoItem>);
}

export default NoItemFound;


NoItemFound.defaultProps = {
    show_contact_modal: true,
}